//Trump properties
var allProperties = ["United States", "Phoenix", "Orlando", "Las Vegas", "Austin", "Atlanta", "Charlotte"];

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;

//Loads the data
d3.csv("data/latino.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.LatinoPercent = +d.LatinoPercent;
    d.year = parseDate(d.year);
  });

  //Organizes the data
  //data.sort(function(a,b) { return a.year - b.year; });
  var maxY = d3.max(data, function(d) { return d.LatinoPercent; });
  var maxX = d3.max(data, function(d) { return d.year; });
  var minX = d3.min(data, function(d) { return d.year; });

  //Map the property names to the data
  allProperties = d3.set(data.map(function(d) { return d.city; })).values();

  allProperties = allProperties.filter(function(d) { return d != "United States"})

  //Make a chart for each property
  var charts = allProperties.map(makeChart);

  d3.select(window).on("resize", function () {
    charts.forEach(function(chart) {
      chart.resize();
    })
  });

  function makeChart(name, chartIndex) {

    //Append individual chart div
    var chartContainer = d3.select(".gia-chart").append("div")
      .attr("class", "g-chart-container");

    //Margin conventions
    var margin = {top: 5, right: 10, bottom: 15, left: 21};

    var widther = d3.select(".g-chart-container").node().clientWidth;

    var width = (widther) - margin.left - margin.right,
      height = 200 - margin.top - margin.bottom;

    //Creates the xScale
    var xScale = d3.time.scale()
      .range([0, width]);

    //Creates the yScale
    var yScale = d3.scale.linear()
      .range([height, 0]);

    //line function convention (feeds an array)
    var line = d3.svg.line()
      .x(function(d) { return xScale(d.year); })
      .y(function(d) { return yScale(d.LatinoPercent); });

    //area function
    var area = d3.svg.area()
      .x(function(d) {return xScale(d.year); })
      .y0(height)
      .y1(function(d) {return yScale(d.LatinoPercent); });

    //Defines the xScale max
    xScale.domain(d3.extent(data, function(d) { return d.year; }));

    //Defines the yScale max
    yScale.domain([0, maxY]);

    //Defines the y axis styles
    var yAxis = d3.svg.axis()
      .scale(yScale)
      .tickSize(-width)
      .tickPadding(4)
      .ticks(5)
      .orient("left");

    //Defines the y axis styles
    var xAxis = d3.svg.axis()
      .scale(xScale)
      .tickPadding(0)
      .orient("bottom")
      .tickValues([minX, maxX])
      .tickFormat(d3.time.format("%Y"));

    //Finds the data associated with each property name
    var myLocationName = name;

    var myLocationData = data.filter(function(d) {
      return d.city === myLocationName;
    });

    myLocationData = myLocationData.filter(function(d) { return d.city != "United States"})

    //Sets value for ending dot on line
    var maxXdot = d3.max(myLocationData, function(d) { return d.year; });

    var cityName = d3.max(myLocationData, function(d) { return d.state; });

    //Appends chart heading div
    var chartHeading = chartContainer.append("div")
      .attr("class", "g-heading");  

    //Appends the property name to the individual chart container
    var chartLocation = chartHeading.append("h5")
      .attr("class", "g-property");  

    //Appends the property name to the individual chart container
    var chartCity = chartHeading.append("p")
      .attr("class", "g-city");   

    //Appends the property chart to the individual chart container
    var chart = chartContainer.append("div")
      .attr("class", "g-chart");

    //Assigns the property name
    chartLocation.text(myLocationName);
    chartCity.text(cityName);

    //Appends the svg to the chart-container div
    var svg = chart.append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    //Appends the y axis
    var yAxisGroup = svg.append("g")
      .attr("class", "y axis")
      .call(yAxis)
      .selectAll("g")
      .classed("g-baseline", function(d) {return d == 0});

    //Appends the x axis
    var xAxisGroup = svg.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)
      .selectAll("g")
      .classed("g-start", function(d) {return d == minX})
      .classed("g-end", function(d) {return d == maxX});

    //Binds the data to the area
    var drawarea = svg.append("path")
      .datum(myLocationData)
      .attr("class", "area")
      .attr("d", area);

    //Binds the data to the line
    var drawline = svg.append("path")
      .datum(myLocationData)
      .attr("class", "line")
      .attr("d", line)
      .selectAll("line");

    //Binds the data to the line
    var drawUS = svg.append("path")
      .datum(data.filter(function(d){ return d.city == "United States" }))
      .attr("class", "USline")
      .attr("d", line)
      .selectAll("line");    

    //Adding circle label
    var labelElements = svg.append("g")
      .attr("class", "fiddly-bits")

    var label = labelElements.selectAll(".g-label-element")
      .data(myLocationData.filter(function(d) { return d.year == maxXdot; }))
      .enter().append("g")
      .attr("class", function(d, i) { return 'g-label-element'+i;})
      .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.LatinoPercent) + ")"; } );

    label.append("circle")
      .attr("r", 3)
      .attr("class", "g-label-circle");

    if(chartIndex == 0) {
      //Append US note 
      var USlabel = svg.append("text")
        .text("US change")
        .attr("class", "USlabel")
        .attr("x", width/1.1)
        .attr("y", height/1.8)

      d3.select(".line")
        .attr("class", "line-Charlotte"); 

      d3.select(".area")
        .attr("class", "area-Charlotte");  

      d3.select(".g-label-circle")  
        .attr("class", "g-label-circle-Charlotte")
    }    

    return {
      resize: function () {
        //new margin
        var newMargin = {top: 5, right: 10, bottom: 15, left: 21};

        var newWidther = d3.select(".g-chart-container").node().clientWidth;

        var newWidth = (newWidther) - newMargin.left - newMargin.right;

        //Change the width of the svg
        d3.selectAll("svg")
          .attr("width", newWidth + newMargin.left + newMargin.right);

        //Change the xScale
        xScale
          .range([0, newWidth]);

        //Update the line
        line = d3.svg.line()
          .x(function(d) { return xScale(d.year); })
          .y(function(d) { return yScale(d.LatinoPercent); });

        d3.selectAll('.line')
          .attr("d", line);

        d3.selectAll('.line-Charlotte')
          .attr("d", line);  

        d3.selectAll('.USline')
          .attr("d", line);  

        d3.select(".USlabel")  
          .attr("x", newWidth/1.1)    

        //Update the area
        area = d3.svg.area()
          .x(function(d) {return xScale(d.year); })
          .y0(height)
          .y1(function(d) {return yScale(d.LatinoPercent); });

        d3.selectAll('.area')
          .attr("d", area);

        d3.selectAll('.area-Charlotte')
          .attr("d", area);  

        //Updates label
        d3.selectAll('.g-label-element0')
          .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.LatinoPercent) + ")"; } );

        //Updates xAxis
        d3.selectAll(".x.axis")
          .call(xAxis);

        xAxis
          .scale(xScale);

        //Updates yAxis
        d3.selectAll(".y.axis")
          .call(yAxis);

        yAxis
          .tickSize(-newWidth);

        //Updates overlay
        d3.selectAll(".overlay")
          .attr("width", newWidth);
      }
    };
  }
}